import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=5ae03c65"
import script from "./uploads.vue?vue&type=script&lang=js"
export * from "./uploads.vue?vue&type=script&lang=js"
import style0 from "./uploads.vue?vue&type=style&index=0&id=5ae03c65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports